import Investment from '@nerdwallet/react-icon/nerdwallet-brand/Investment';
import Insurance from '@nerdwallet/react-icon/nerdwallet-brand/Insurance';
import StudentLoans from '@nerdwallet/react-icon/nerdwallet-brand/StudentLoans';
import Mortgage from '@nerdwallet/react-icon/nerdwallet-brand/Mortgage';
import PersonalLoans from '@nerdwallet/react-icon/nerdwallet-brand/PersonalLoans';
import Savings from '@nerdwallet/react-icon/nerdwallet-brand/Savings';
import CreditCard from './icons/credit-card'; // TODO: fix and use react-icon/nerdwallet-brand/creditCard

export default {
  tiles: [
    {
      nav: 'Credit Cards',
      IconComponent: CreditCard,
      url: '/the-best-credit-cards?trk=hp_tiles_cc&trk_copy=hpbestcc',
      backgroundColor: '#DEEFFF',
      iconColor: '#54A0E8',
    },
    {
      nav: 'Investing',
      IconComponent: Investment,
      url:
        '/blog/category/investing/?trk=hp_tiles_begininvest&trk_copy=hpbegininvest',
      backgroundColor: '#E3F9F1',
      iconColor: '#55B78A',
    },
    {
      nav: 'Insurance',
      IconComponent: Insurance,
      url:
        '/blog/category/insurance?trk=hp_tiles_insurance&trk_copy=hpinsurance',
      backgroundColor: '#FAE3E3',
      iconColor: '#FF9090',
    },
    {
      nav: 'Student Loans',
      IconComponent: StudentLoans,
      url:
        '/blog/category/loans/student-loans?trk=hp_tiles_studentloans&trk_copy=hpstudentloans',
      backgroundColor: '#E9E2E9',
      iconColor: '#9F6A93',
    },
    {
      nav: 'Mortgage',
      IconComponent: Mortgage,
      url:
        '/blog/category/mortgages?trk=hp_tiles_bestmortgage&trk_copy=hpbestmortgage',
      backgroundColor: '#FEEFD0',
      iconColor: '#EFA92E',
    },
    {
      nav: 'Personal Loans',
      IconComponent: PersonalLoans,
      url:
        '/blog/category/personal-loans?trk=hp_tiles_pltooltop&trk_copy=hppltooltop',
      backgroundColor: '#DEEFFF',
      iconColor: '#4B99E6',
    },
    {
      nav: 'Banking',
      IconComponent: Savings,
      url: '/blog/category/banking?trk=hp_tiles_bhyostop&trk_copy=hpbhyostop',
      backgroundColor: '#E3F9F1',
      iconColor: '#40AD87',
    },
  ],
};

export const experimentalHeroNavContent = {
  tiles: [
    {
      nav: 'Credit Cards',
      IconComponent: CreditCard,
      url: '/credit-cards?trk=hp_tiles_creditcards&trk_copy=hpcreditcards_var',
      backgroundColor: '#DEEFFF',
      iconColor: '#54A0E8',
    },
    {
      nav: 'Investing',
      IconComponent: Investment,
      url:
        '/blog/category/investing/?trk=hp_tiles_begininvest&trk_copy=hpbegininvest',
      backgroundColor: '#E3F9F1',
      iconColor: '#55B78A',
    },
    {
      nav: 'Insurance',
      IconComponent: Insurance,
      url:
        '/blog/category/insurance?trk=hp_tiles_insurance&trk_copy=hpinsurance',
      backgroundColor: '#FAE3E3',
      iconColor: '#FF9090',
    },
    {
      nav: 'Student Loans',
      IconComponent: StudentLoans,
      url:
        '/blog/category/loans/student-loans?trk=hp_tiles_studentloans&trk_copy=hpstudentloans',
      backgroundColor: '#E9E2E9',
      iconColor: '#9F6A93',
    },
    {
      nav: 'Mortgage',
      IconComponent: Mortgage,
      url:
        '/blog/category/mortgages?trk=hp_tiles_bestmortgage&trk_copy=hpbestmortgage',
      backgroundColor: '#FEEFD0',
      iconColor: '#EFA92E',
    },
    {
      nav: 'Personal Loans',
      IconComponent: PersonalLoans,
      url:
        '/blog/category/personal-loans?trk=hp_tiles_pltooltop&trk_copy=hppltooltop',
      backgroundColor: '#DEEFFF',
      iconColor: '#4B99E6',
    },
    {
      nav: 'Banking',
      IconComponent: Savings,
      url: '/blog/category/banking?trk=hp_tiles_bhyostop&trk_copy=hpbhyostop',
      backgroundColor: '#E3F9F1',
      iconColor: '#40AD87',
    },
  ],
};
